import { useEffect } from "react"
import { Grid, Box } from "@mui/material"
import DoughnutChart from "./DoughnutChart"
import CircularProgress from '@mui/material/CircularProgress';

function DoughnutDashboard({ data }) {
    // Checagem robusta de dados v�lidos
    const hasData =
        data &&
        Array.isArray(data.labels) &&
        data.labels.length > 0 &&
        data.datasets &&
        Array.isArray(data.datasets) &&
        data.datasets.length > 0 &&
        Array.isArray(data.datasets[0].data) &&
        data.datasets[0].data.some(v => v > 0);

    return (
        <>
            {hasData ? (
                <div style={{ width: "100%", borderRadius: 12 }}>
                    <DoughnutChart chart={data} />
                </div>
            ) : null}
        </>
    )
}

export default DoughnutDashboard